import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { IAutoplayOptions } from "../store/interfaces";
import { RoundRepository } from "../round.repository";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { IRound } from "../interfaces";

@Injectable()
export class GetAutoplayUseCase implements IUseCase<number, Observable<IAutoplayOptions | undefined>> {
    constructor(private roundRepository: RoundRepository) {}

    execute(betIndex: number): Observable<IAutoplayOptions | undefined> {
        return this.roundRepository.get().pipe(map((round: IRound) => round.autoplayOptions.find(b => b.betArgs.betIndex === betIndex)));
    }
}
